export function sanitizeEmail(email: string | null) {
    if (!email) return ''
    return email.toLowerCase().trim()
}